import { Component, Input } from '@angular/core'

@Component({
  selector: 'ads-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  public showmenu_Icon: boolean = false;
  public hambugerText: string = 'menu';
  @Input("showHeader") showHeader: boolean = true;
  @Input("showFooter") showFooter: boolean = true;
  @Input("menuHeaderVisible") menuHeaderVisible: boolean = true;
  @Input("menuFooterVisible") menuFooterVisible: boolean = true;
  @Input('style') style: string;
  @Input('menuStaticClass') menuStaticClass: string;
  @Input('menuBindingClass') menuBindingClass: string;
  @Input('expandable') expandable: string;
  @Input("isOffcanvas") isOffcanvas: boolean = false;
  constructor() { }
  changeText() {
    if (this.showmenu_Icon)
      this.hambugerText = 'close';
    else
      this.hambugerText = 'menu';

  }
}
